import { ISectionSchema } from '../Section';
import RuleManager from './RulesManager';

export function getVisibleSection(
  sections: Array<ISectionSchema>,
): Array<ISectionSchema> {
  if (!Array.isArray(sections)) {
    return [];
  }

  return sections
    .filter((section) => section?.extra?.visible !== false)
    ?.filter(
      (_section) =>
        !_section?.controls?.every((_control) => _control?.visible === false),
    );
}

export function visibleControls(state: any): Array<ISectionSchema> {
  const { form, values } = state;
  const sections = form.sections.map((section) => ({ ...section }));

  const manager = new RuleManager({ metaMappings: state.meta_mappings });
  manager.run(sections, values);

  return getVisibleSection(sections);
}

export function getSelection(
  sections: Array<ISectionSchema>,
  values: any,
  section: string,
): ISectionSchema {
  const index = sections.findIndex((sec: any) => sec.id === section);

  return sections[index];
}
